import React from 'react';
import MenuButtons from "../layout/MenuButtons";
import {Outlet} from "react-router-dom";
import ScrollToTop from "../shared/components/common/ScrollToTop";
import '../global-dark-theme.scss';

const DefaultMainPage = ({buttons}) => {
    return (
        <div>
            <MenuButtons buttons={buttons}/>
            <Outlet/>
            <ScrollToTop/>
        </div>
    );
};

export default DefaultMainPage;